import React from "react";
import FloatingWhats from "../Components/FloatingWhats.jsx";
import Header from "../Components/Header.jsx";
import { Grid2 } from "@mui/material";
import Card from "../Components/Card.jsx";
import BottomBar from "../Components/BottomBar.jsx";
import Footer from "../Components/Footer.jsx";

const Produtos = () => {


    return (
        <div className="container">
            <FloatingWhats/>
            <Header/>
            <div className="content">
                <div className="bannerInterno-container from-top">
                    <div className="bannerInterno-content">
                        <div className="bannerInterno">
                            <h1 className="bannerInterno-title">Produtos<br/>Balanças Cuiabá</h1>
                            <img className="bannerInterno-img" src="../images/produtos.png" alt="Banner Produtos"/>
                        </div>
                    </div>
                </div>
                <div className="caminho">
                    <div className="caminho-content from-left">
                        <a className="caminho-link" href="/">Início</a>
                        <span className="caminho-separador">/</span>
                        <span className="caminho-atual">Produtos</span>
                    </div>
                </div>
                <div className="produtos from-bottom">
                    <div className="lista-produtos">
                        <Grid2 className='produtos-grid' columns={{ xs:4, sm:8, md:12}} container spacing={5}>
                            <Grid2 item>
                                <Card link='/produtos/pesagem-rodoviaria' cardImg={`../images/pesagem-rodoviaria.png`} title='Pesagem Rodoviária'/>
                            </Grid2>
                            {/* <Grid2 item>
                                <Card link='/produtos/tulhas-e-balancas-de-fluxo' cardImg={`../images/tulha-fluxo.png`} title='Tulhas e Balanças de Fluxo'/>
                            </Grid2>
                            <Grid2 item>
                                <Card link='/produtos/linha-industrial' cardImg={`../images/linha-industrial.png`} title='Linha Industrial'/>
                            </Grid2> */}
                            {/* <Grid2 item>
                                <Card link='/produtos/automacao-rodoviaria' cardImg={`../images/automacao-rodoviaria.png`} title='Automação Rodoviária'/>
                            </Grid2> */}
                        </Grid2>
                    </div>
                </div>
                <BottomBar/>
                <Footer/>
            </div>
        </div>
    )
}
export default Produtos;